import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ballotRoute } from '../route-names';
import { ScreenOrderService, SelectedReturnMethod } from '../Services/screen-order.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';


@Component({
    selector: 'app-return-options',
    templateUrl: './return-options.component.html',
    styleUrls: ['./return-options.component.scss'],
    standalone: false
})
export class ReturnOptionsComponent implements AfterViewInit {
  routeName = ""

  constructor(
    private readonly announcer: LiveAnnouncer,
    private readonly router: Router,
    private screenOrder: ScreenOrderService,
    ) {}

  toBallot(method: SelectedReturnMethod) {
    this.screenOrder.selectedReturnMethod = method;
    this.screenOrder.returnMethodSelected = true;
    this.router.navigate(ballotRoute);
  }

  ngAfterViewInit() {
    this.routeName = this.router.url
    this.resetFocus()
    this.announcer.announce($localize`Ballot Return Options  select how do you want to return your ballot`,"assertive") 
 
  }
  resetFocus() {
    let focusField = document.getElementById('accessibility-button')
    let focusFieldMobile = document.getElementById('accessibility-button-mobile')
  
    if (focusField) {
      focusField.focus()
    }

    if (focusFieldMobile) {
     focusFieldMobile.focus()
    }
  }
}
